import styled from "@emotion/styled";
import { LightMode, Variables } from "@repo/skapa";
import ReactQuill from "react-quill-new";
import "react-quill-new/dist/quill.snow.css";

const TOOLBAR_OPTIONS = [
  [{ size: ["small", false, "large", "huge"] }],

  ["bold", "italic", "underline", "strike"],

  [{ color: [] }, { background: [] }],

  [{ script: "sub" }, { script: "super" }],

  [{ header: 1 }, { header: 2 }, "blockquote", "code-block"],

  [{ list: "ordered" }, { list: "bullet" }, { indent: "-1" }, { indent: "+1" }],

  [{ direction: "rtl" }, { align: [] }],

  ["link", "image"],

  ["clean"],
];

const FORMATS = [
  "size",
  "bold",
  "italic",
  "underline",
  "strike",
  "color",
  "background",
  "script",
  "header",
  "blockquote",
  "code-block",
  "list",
  "bullet",
  "indent",
  "direction",
  "align",
  "link",
  "image",
];

const EditorWrapper = styled.div<{ height: number }>`
  margin-top: ${Variables.space50};

  .ql-toolbar {
    border: 1px solid ${LightMode.colourNeutral5};
  }

  .ql-container {
    height: ${({ height }) => height}px;
    border: 1px solid ${LightMode.colourNeutral5};
  }

  .ql-editor {
    font-family:
      "Noto IKEA Latin", "Noto IKEA", "Noto Sans", "Roboto", "Open Sans",
      sans-serif;
    font-size: 14px;
    line-height: 1.5;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }
`;

interface EmailEditorProps {
  value: string;
  onChange: (value: string) => void;
  height?: number;
}

export const EmailEditor = ({
  value,
  onChange,
  height = 400,
}: EmailEditorProps) => {
  return (
    <EditorWrapper height={height}>
      <ReactQuill
        theme="snow"
        value={value}
        onChange={onChange}
        modules={{ toolbar: TOOLBAR_OPTIONS }}
        formats={FORMATS}
      />
    </EditorWrapper>
  );
};
